import { supabase } from "~/integrations/supabase/client";

export interface CxcValidationFilters {
  initialDate: string; // YYYY-MM-DD
  finalDate: string; // YYYY-MM-DD
}

export interface CxcValidationLine {
  concepto: string;
  monto: number;
  detalle: {
    fecha?: string;
    descripcion?: string;
    periodo_desde?: string;
    periodo_hasta?: string;
    cantidad?: number;
    tipo?: string;
    formula?: string;
    fuente?: string;
    alerta?: "REVISAR" | "OK";
  };
}

export const cxcValidationService = {
  async getCxcMovementValidation(
    filters: CxcValidationFilters
  ): Promise<CxcValidationLine[]> {
    const { data, error } = await supabase.rpc("get_cxc_movement_validation", {
      p_initial_date: filters.initialDate,
      p_final_date: filters.finalDate,
    });

    if (error) throw error;
    return data as CxcValidationLine[];
  },
};
